var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.reportStatisticComponent,_vm._b({tag:"component"},'component',{ currency: _vm.currency, type: _vm.type },false))
}
var staticRenderFns = []

export { render, staticRenderFns }